


















































































































































import { Component, Prop } from "vue-property-decorator";
// import EditComponent from "@/editor/EditComponent";
import EditPage from "@/components/EditPage";
import EditDateRange from "@/editor/EditDateRange.vue";
import { Globals } from "@/Globals";
import {
  getKennungValueDisplay,
  getKennungValue,
  getKennungTitle,
  getColumnByKennung,
} from "@/DataHelper";
import { showSnackbar } from "@/UIHelper";
import { calcFunctionNew } from "@/CalcHelperStatic";

@Component
export default class Dialog extends EditPage {
  @Prop() public zeitbereichUebergabe!: APIZeitbereich | null;
  @Prop() public checkDateRange!:
    | ((von: Date, bis: Date, aic: string) => boolean)
    | undefined;
  private IsAllDay: boolean = false;
  private color: string = "success";
  private stellVertreter: boolean = false;
  private disabled: boolean = false;
  private stellBew: boolean = false;
  private date: any = "";
  private bewilligung: boolean = false;
  private stellOffen: boolean = false;
  private maName: string = "";
  private zeitart: string = "";
  private maNameTitel: string = "";
  private zeitartTitel: string = "";
  private b2: string = "";
  private b2Aic: number = 0;
  private b2Titel: number = 0;
  private checkStellvertreter: string = "";
  private resturlaub: string | undefined = "";
  private loading: boolean = false;
  private loader: any = null;
  private aicOffen: number = 0;
  private aicEig: number = 0;
  protected saveVisible: boolean = false;
  protected deleteVisible: boolean = false;
  private editErlaubt: boolean = false;
  private saveModell = "WEB_PZE_PlanungDoppelbuchungen";
  @Prop() public tag: Date | null = null;

  constructor() {
    super();
    this.query = "Web_Planung_Dienstplan";
    this.showLoading = true;
    this.editErlaubt = true;
    this.saveVisible = true;
    this.deleteVisible = true;
    this.step = 1;
  }
  public created() {
    this.zeitbereich = this.zeitbereichUebergabe;
    if (!this.checkBegriff("Web_DP_FehlzeitenEditierbar")) {
      this.deleteVisible = false;
      this.saveVisible = false;
      this.disabled = true;
    }
  }
  public get showDelete() {
    return this.data && this.data.aic_Bew_pool && this.data.aic_Bew_pool > 0;
  }

  public bewDelete() {
    if (this.data && this.data.aic_Bew_pool) {
      this.onDelete(this.data.aic_Bew_pool, "");
      this.$emit("backDelete");
    }
  }
  private checkValue(evt: any) {
    const value = evt.value;
    const combo = evt.field.meta.combo;
    const textOffen = combo[0].bezeichnung;
    const aktAic = combo[2].aic; // = abgelehnt
    if (value === aktAic) {
      this.b2Aic = this.aicOffen;
      this.b2 = textOffen;
      const spalte = "e" + this.aicEig;
      for (const i in this.data) {
        if (i === spalte) {
          this.data[i] = this.b2Aic;
        }
      }
    }
  }
  protected initialize() {
    if (!this.checkBegriff("Web_DP_FehlzeitenEditierbar")) {
      this.deleteVisible = false;
      this.saveVisible = false;
      this.disabled = true;
    }

    this.maNameTitel = getKennungTitle("MA", this.columns);
    this.zeitartTitel = getKennungTitle("ZA", this.columns);
    this.maName = getKennungValueDisplay(this.data, "MA", this.columns);
    this.zeitart = getKennungValueDisplay(this.data, "ZA", this.columns);
    const allDay = getKennungValueDisplay(this.data, "B_CALC_FIELD", this.columns);
    if (allDay === true) {
      this.IsAllDay = true;
    }
    const zuBewilligen = getKennungValueDisplay(this.data, "GRANTED", this.columns);
    if (zuBewilligen === "ja") {
      this.bewilligung = true;
    }
    const checkBewilligt = getKennungValueDisplay(this.data, "b1", this.columns);
    this.checkStellvertreter = getKennungValueDisplay(this.data, "SV", this.columns);

    if (this.checkStellvertreter) {
      this.stellVertreter = true;
      this.b2Titel = getKennungTitle("b2", this.columns);
      this.b2 = getKennungValueDisplay(this.data, "b2", this.columns);
      this.b2Aic = getKennungValue(this.data, "b2", this.columns);
      const column = getColumnByKennung("b2", null, this.columns);
      const combo = column.meta.combo;
      this.aicEig = column.aicEig;
      this.aicOffen = combo[0].aic;

      if (this.b2 === "bewilligt") {
        this.stellBew = true;
      } else if (checkBewilligt === "offen") {
        this.stellOffen = true;
      }
    }
    const self = this.checkBegriff("Web_VG_Selfservice");
    if (!self) {
      const maAIC = getKennungValue(this.data, "MA", this.columns);
      const userAIC = this.$api.user.aic;
      if (maAIC === userAIC) {
        this.disabled = true;
      }
    }
  }
  private checkChanged(val: any) {
    if (this.checkBegriff("Web_DP_FehlzeitenEditierbar")) {
      this.saveVisible = true;
    }
  }
  private checkIntersection(skipChanging: boolean = false) {
    if (this.checkDateRange) {
      const dateRange = this.$refs.dateRange as EditDateRange;
      if (
        dateRange &&
        (skipChanging || dateRange.changing) &&
        dateRange.von &&
        dateRange.bis
      ) {
        const von = dateRange.von;
        let bis = dateRange.bis;
        if (von.valueOf() === bis.valueOf() && dateRange.IsAllDay) {
          bis = bis.addDays(1);
        }
        if (!this.checkDateRange(von, bis, this.data.aic_Bew_pool)) {
          return false;
        }
      }
    }
    return true;
  }
  private save() {
    if (!this.checkIntersection()) {
      showSnackbar(
        this.$globalsBezeichnung(Globals.Begriff, "Ueberschneidung", "Überschneidung!")
      );
      return;
    }
    const aicAbfAllBez = this.$globalsKennung(Globals.Begriff, "WebPlanungSpeichern");
    const varName = "BewAic";
    const varUbergabe: any[] = [];
    if (this.data.aic_Bew_pool) {
      const wert = this.data.aic_Bew_pool;

      varUbergabe.push({
        var: varName,
        type: "double",
        wert,
        art: 2,
        user: this.$api.user.user,
        perm: false,
      });
    }

    const me = this;
    const dateRange = this.$refs.dateRange as EditDateRange;
    let vonModellZeitbereich = dateRange.von;

    const vonZeitbereich = this.zeitbereichUebergabe?.von ?? this.zeitbereich?.von;

    if (vonZeitbereich && vonModellZeitbereich) {
      if (vonModellZeitbereich > vonZeitbereich) {
        vonModellZeitbereich = vonZeitbereich;
      }
    }
    let bisModellZeitbereich = dateRange.bis;
    let bisZeitbereich = this.zeitbereichUebergabe?.bis ?? this.zeitbereich?.bis;
    // siteData BIS ist 1 Tag MEHR!

    if (bisModellZeitbereich && bisZeitbereich) {
      bisZeitbereich = new Date(bisZeitbereich).addDays(-1);
      if (bisModellZeitbereich < bisZeitbereich) {
        bisModellZeitbereich = bisZeitbereich;
      }
    }
    const modellZeitbereich = {
      von: vonModellZeitbereich,
      bis: bisModellZeitbereich,
      bereich: "Tag",
    };
    calcFunctionNew(
      this.saveModell,
      this.aic,
      false,
      me,
      modellZeitbereich,
      varUbergabe
    )?.then((response: any) => {
      if (response !== "Error" && response?.msgType !== "Error") {
        if (aicAbfAllBez) {
          const aicAbfAll = aicAbfAllBez.aic;
          me.onSave(aicAbfAll, "", modellZeitbereich)?.then(() => {
            this.$nextTick(() => me.$emit("save"));
            // me.$emit("save");
          });
        } else {
          showSnackbar({
            text: "Abfrage nicht gefunden",
            color: "error",
          });
          this.showLoading = false;
          return;
        }
      }
      return;
    });
  }
  private calcSalden() {
    this.loading = true;

    const modell = "Web_Resturlaub_per_Stichtag";
    let begriff: any;
    if (modell) {
      begriff = this.$globalsKennung(Globals.Begriff, modell);
    }
    this.$api.postCalc(
      [],
      [],
      begriff.aic,
      this.aic,
      this.zeitbereich,
      0,
      0,
      "",
      this.successCalc,
      begriff.maxB
    );
  }
  private successCalc(res: any) {
    this.resturlaub = res.data.ergebnis;
    this.loading = false;
    this.step++;
    return;
  }
}
